import { memo, useMemo } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HistogramModule from 'highcharts/modules/histogram-bellcurve';

HistogramModule(Highcharts);
NoDataToDisplay(Highcharts);

const HCHistogram = memo(({ title, data, chartKey, series, color="#40affe" }) => {

  // data = data ?  data : [610, 880, 880, 860, 720, 720, 620, 860, 970, 950, 880, 910, 850, 870, 840, 840, 850, 840, 840, 840, 61];    
  const cleanedData = data?.filter(value => typeof value === 'number' && !isNaN(value));

  const options = useMemo(() => ({
    chart: {
        height: 250,
    },
    title: {
      text: title,
    },
    xAxis: {
      title: { text: "" },
      alignTicks: true,
    },
    yAxis: {
      title: { text: "" },
    },
    noData: {
      useHTML: true,
      style: {
          fontSize: '14px',
          fontWeight: 'normal',
          color: '#8a8a8a',
      },
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    plotOptions: {
      histogram: {
        accessibility: {
          point: {
            valueDescriptionFormat:
              "{index}. {point.x:.3f} to " + "{point.x2:.3f}, {point.y}.",
          },
        },
      },
    },
    series: [
      {
        name: "Data",
        type: "scatter",
        data: cleanedData,
        id: "scatter",
        marker: {
          radius: 1.5,
        },
        visible: false,
      },
      {
        name: "Histogram",
        type: "histogram",
        baseSeries: "scatter",
        // binWidth: 10,
        color: color,
      },
    ],
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: true,
      outside: true,
      zIndex: 20,
      headerFormat: "",
      // formatter: function () {
      //   if (this.point.custom?.empty) return null;
      //   return Highcharts.dateFormat("%A, %b %e, %Y", this.point.date);
      // },
      nullFormat: "No data",
      backgroundColor: "#fafafa",
      borderWidth: 0,
      padding: 6,
      className: "",
      useHTML: true,
      formatter: function () {
        return `
          <div class="text-center"> 
            <div class="mb05 bold">
              ${"Histogram : " + this.point.y} 
            </div>
            <b>${this.point.x?.toFixed(0)+ " - " + this.point.x2?.toFixed(0)}</b>
          </div>`
      }
    }
  }), []);

  return(
    <div>
    <HighchartsReact 
      highcharts={Highcharts} 
      options={options} 
      key={chartKey}
    />
    </div>
  )
})

export default HCHistogram;